import { render, staticRenderFns } from "./ControlerLayersMTK.vue?vue&type=template&id=56c46794&scoped=true"
import script from "./ControlerLayersMTK.vue?vue&type=script&lang=js"
export * from "./ControlerLayersMTK.vue?vue&type=script&lang=js"
import style0 from "./ControlerLayersMTK.vue?vue&type=style&index=0&id=56c46794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c46794",
  null
  
)

export default component.exports